import { LCDClient, TxInfo } from "@terra-money/feather.js"
import { LoadingToast } from "components/toasts/LoadingToast"
import { TxToast } from "components/toasts/TxToast"
import { createRoot } from "react-dom/client"
import { CLASSIC_CHAIN_ID } from "./Constants"

export const showLoadingToast = async <T,>(message: string, task: () => Promise<T>) => {
    return new Promise<T>((resolve, reject) => {
        const parent = document.createElement('div')
        const root = createRoot(parent)
        root.render(
            <LoadingToast
                task={task}
                onSuccess={(res) => {
                    setTimeout(() => root.unmount(), 2000)
                    resolve(res)
                }}
                onComplete={() => { }}
                onError={() => { }}
                message={message} />
        )

        const container = document.querySelector(".toast-container")
        container?.appendChild(parent)
    })
}

export const showTxToast = async (txHash: string) => {
    return new Promise<TxInfo>((resolve, reject) => {
        const parent = document.createElement('div')
        const root = createRoot(parent)
        root.render(
            <TxToast
                task={async () => {
                    const lcd = new LCDClient({
                        [CLASSIC_CHAIN_ID]: {
                            chainID: CLASSIC_CHAIN_ID,
                            gasAdjustment: 1,
                            gasPrices: "0.015uluna",
                            lcd: "https://terra-classic-lcd.publicnode.com",
                            prefix: "terra"
                        }
                    })
                    for (let i = 0; i < 60; i++) {
                        try {
                            const result = await lcd.tx.txInfo(txHash, CLASSIC_CHAIN_ID)

                            return result
                        } catch { }
                        await (new Promise((res, rej) => setTimeout(() => res(null), 1000)))
                    }
                    throw "Transaction failed: timeout"
                }}
                onSuccess={(res) => {
                    resolve(res)
                }}
                onComplete={() => { }}
                onError={() => { }}
                txHash={txHash} />
        )

        const container = document.querySelector(".toast-container")
        container?.appendChild(parent)
    })
}